
import { MutationTree } from 'vuex';

import { State } from './state';
import { AuthMutationTypes } from './mutation-types';
import { UserLogged } from '@/models/auth/user-logged.model';



export type Mutations<S = State | any> = {
    [AuthMutationTypes.LOGIN_SUCCESS](state: S, integracao: any): void;
    [AuthMutationTypes.LOGIN_FAILURE](state: S): void;
    [AuthMutationTypes.LOGOUT](state: S, user: any): void;
    [AuthMutationTypes.REGISTER_FAILURE](state: S): void;
    [AuthMutationTypes.REGISTER_SUCCESS](state: S): void;
    [AuthMutationTypes.REGISTER_SUCCESS](state: S): void;
    [AuthMutationTypes.SET_TOKEN_LEGACY](state: S, token: string): void;

}


export const mutations: MutationTree<State> & Mutations = {
    [AuthMutationTypes.LOGIN_SUCCESS](state: State, integracao: any) {
        state.integracao.usuarioIntegracaoId = integracao.segUsuarioId;
        state.integracao.code = integracao.code;
        state.integracao.grupoUsuario = integracao.grupoUsuario;
        localStorage.setItem('integracao', JSON.stringify(state.integracao));
    },
    [AuthMutationTypes.LOGOUT](state: State, user: UserLogged) {
        state.oidc.value.userManager!.signoutRedirect();
        localStorage.removeItem('integracao');
        localStorage.removeItem('messages');
        localStorage.removeItem('ultimaObraSelecionada');
    },
    [AuthMutationTypes.LOGIN_FAILURE](state: State) {


    },
    [AuthMutationTypes.REGISTER_SUCCESS](state: State) {

    },
    [AuthMutationTypes.REGISTER_FAILURE](state: State) {

    },
    [AuthMutationTypes.SET_TOKEN_LEGACY](state: State, token: string) {
        sessionStorage.setItem('tokenLegacy', token);
        sessionStorage.setItem('isLegacy', '1');
    }
};
